import * as React from 'react';
import autobind from 'autobind-decorator';
import { observer } from 'mobx-react';

import { AgentPolicyView } from './agent-policy.view';
import { AgentPolicyDataService } from './agent-policy-form.data';

interface Props extends ComponentViewProps<AgentItem> {
	dataService: AgentPolicyDataService;
	mode: ControlMode;
}

@observer
export class AgentPolicyController extends React.Component<Props, {}> {
	@autobind
	private async handleCreateAgentPolicy(): Promise<AgentPolicyItem> {
		const { dataService, model } = this.props;
		return await dataService.add(model);
	}

	@autobind
	private swapDownPriorities(index: number): void {
		const { dataService } = this.props;
		const [previous] = dataService.items.splice(index - 1, 1);
		dataService.items.splice(index, 0, previous);
		
		dataService.items[index].priority = index;
		dataService.items[index - 1].priority = index - 1;
	}

	render(): React.ReactNode {
		const { dataService, mode, setBusy } = this.props;
		if (dataService == null || dataService.items == null) {
			return null;
		}

		return (
			<AgentPolicyView
				model={dataService}
				onCreateAgentPolicy={this.handleCreateAgentPolicy}
				swapDownPriorities={this.swapDownPriorities}
				mode={mode}
				setBusy={setBusy}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agent-policies/agent-policy.controller.tsx